<template>
  <div :class="['radius',classes]" v-if="breadcrumbArr.length">
    <i class="iconfont icon-dangqianweizhi"></i>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item,index) in breadcrumbArr" :key="index" :to="{path:item.path}">
          {{item.title}}
        </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-page-breadcrumb'

export default {
  name: 'pt-page-breadcrumb',
  props: {
    breadcrumbArr: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
:global
.pt-page-breadcrumb{
  padding-left: 30px;
  margin-bottom: 30px;
  display: inline-block;
  i.icon-dangqianweizhi{
    margin-right: 10px;
    color: #409eff;
  }
    .el-breadcrumb{
        display: inline-block;
        vertical-align: middle;
        line-height: 40px;
        .el-breadcrumb__item{
          &:last-child .el-breadcrumb__inner{
            color: #409eff;
          }
        }
    }
}
</style>
